// import React, { useContext, useEffect } from "react";
// import URLstateContext from "../../provider/CommonContext";
// import HomeBanner from "./HomeBanner/HomeBanner";
// import OurFunds from "./OurFunds/OurFunds";
// import TrendingMFNew from "./TrendingMF/TrendingMFNew";
// import GoalPlanner from "./GoalPlanner/GoalPlanner";
// import Milestone from "./Milestone/Milestone";
// import LookingFor from "./LookingFor/LookingFor";
// import Blog from "./Blog/Blog";
// import Download from "./Download/Download";
// import ModalPopup from "../ModalPopup/ModalPopup";
// import PopupButton from "../HomePopup/PopupButton";
// import SebiPopup from "../HomePopup/SebiPopup";
// // import { Helmet } from "react-helmet-async";
// import { trackEvent, trackPageView } from "../utils/tracking";
// import { Helmet, HelmetProvider } from "react-helmet-async";

// function Home() {
//   const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } =
//     useContext(URLstateContext);

//   useEffect(() => {
//     trackPageView("https://www.jmfinancialmf.com/", "jmf_home");
//     // trackPageView("http://localhost:710/", "jmf_home");

//     trackEvent({
//       category: "Static Page",
//       action: "Home Page Loaded",
//       label: "jmf_home",
//       // value: 1,
//     });
//   }, []);

//    useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   return (
//     <>
//       <HelmetProvider>
//         <Helmet>
//           <meta charset="UTF-8" />
//           <meta
//             name="viewport"
//             content="width=device-width, initial-scale=1.0"
//           />
//           <meta
//             name="keywords"
//             content="jmf_home, JM Financial Mutual Fund, mutual funds, investment"
//           />
//           <meta
//             name="description"
//             content="Explore a wide range of mutual fund schemes with JM Financial Mutual Fund. Achieve your financial goals through diversified investment options managed by seasoned professionals."
//           />
//           <title>
//             JM Financial Mutual Fund | Trusted Wealth Management Solutions
//           </title>
//         </Helmet>
//       </HelmetProvider>
//       <div className="homePage" style={{ fontSize: `${fontSize}px` }}>
//         {/* <ModalPopup/> */}
//         {/* <SebiPopup/> */}
//         <PopupButton />
//         <HomeBanner />
//         <TrendingMFNew />
//         <OurFunds />
//         {/* <GoalPlanner /> */}
//         {/* <Milestone /> */}
//         <LookingFor />
//         <Blog />
//         {/* <Download /> */}
//       </div>
//     </>
//   );
// }
// export default Home;

import React, { useContext, useEffect, useState } from "react";
import URLstateContext from "../../provider/CommonContext";
import HomeBanner from "./HomeBanner/HomeBanner";
import OurFunds from "./OurFunds/OurFunds";
import TrendingMFNew from "./TrendingMF/TrendingMFNew";
import GoalPlanner from "./GoalPlanner/GoalPlanner";
import Milestone from "./Milestone/Milestone";
import LookingFor from "./LookingFor/LookingFor";
import Blog from "./Blog/Blog";
import Download from "./Download/Download";
import ModalPopup from "../ModalPopup/ModalPopup";
import PopupButton from "../HomePopup/PopupButton";
import SebiPopup from "../HomePopup/SebiPopup";
// import { Helmet } from "react-helmet-async";
import { trackEvent, trackPageView } from "../utils/tracking";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ProductSheme from "../Product/ProductSheme/ProductSheme";
import LatestTrendingMF from "./TrendingMF/LatestTrendingMF";
// import SebiImagePopup from "../SebiIamgePopup/SebiImagePopup";
// import SebiImage from "../../images/Pop up WIW 2025.png"
function Home() {
  const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } =
    useContext(URLstateContext);

  useEffect(() => {
    trackPageView("https://www.jmfinancialmf.com/", "jmf_home");
    // trackPageView("http://localhost:710/", "jmf_home");

    trackEvent({
      category: "Static Page",
      action: "Home Page Loaded",
      label: "jmf_home",
      // value: 1,
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="keywords"
            content="jmf_home, JM Financial Mutual Fund, mutual funds, investment"
          />
          <meta
            name="description"
            content="Explore a wide range of mutual fund schemes with JM Financial Mutual Fund. Achieve your financial goals through diversified investment options managed by seasoned professionals."
          />
          <title>JM Financial Mutual Fund- Homepage</title>
        </Helmet>
      </HelmetProvider>
        <HomeBanner />
        <main id="main-content" tabIndex="-1">
      <div className="homePage" style={{ fontSize: `${fontSize}px` }}>
        {/* <ModalPopup/> */}
        {/* <SebiPopup/> */}
        <PopupButton />
        {/* <TrendingMFNew /> */}
        {/* <OurFunds /> */}
        {/* <section><LatestTrendingMF/> </section> */}
        {/* <section><ProductSheme/></section> */}
         <section id="explore-funds"><TrendingMFNew /> </section>
         <section id="video-gallery"><OurFunds /></section>
         <section id="help-section"><LookingFor /></section>
         <section id="insights"><Blog /></section>

        {/* <GoalPlanner /> */}
        {/* <Milestone /> */}
        {/* <LookingFor /> */}
        {/* <Blog /> */}
        {/* <Download /> */}
      </div>
        </main>
    </>
  );
}
export default Home;
